// Layout.js

import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from '../footer/footer';
import Navbar from '../navbar/navbar';
import { isMobile } from 'react-device-detect';
import SidebarContext from '../../contexts/MyContext';

const Layout = ({ children }) => {
    const location = useLocation();
    const path = location.pathname;

    const {user} = useContext(SidebarContext)
    // Signed-in app screens get the app design system; public pages keep their own look.
    const isAppScreen = path === "/dashboard" || path.startsWith("/accountsetting");

    return (
        <div className={isAppScreen ? "layout vr-app" : "layout"}>
            {!(isMobile && path === "/dashboard" || isMobile && path === "/pricing" && user) && <Navbar />}
            <main style={{
                background:
                    path === "/dashboard" ||
                        path.includes("/accountsetting/account") ||
                        path.includes("/accountsetting/settingpassword") ||
                        path.includes("/accountsetting/recordingquality") ||
                        path.includes("/accountsetting/audioformat") ||
                        path.includes("/accountsetting/syncwithcloud") ||
                        path.includes("/accountsetting/support")||
                        path.includes("/accountsetting/manage-plan")
                        ? '#F8FAFC' : "#ffffff"
            }}>
                {children}
            </main>
            {path == "/dashboard" ? "" : <Footer />}
        </div>
    );
}

export default Layout;
